<!-- Internal dropdown -->
@if (isInternalSelection) {
<mat-form-field appearance="fill" style="width: 100%">
  <mat-label>{{ dropDown.label }}</mat-label>
  <mat-select
    [formControl]="control"
    (selectionChange)="onSelectionChange($event.value)"
  >
    @for (item of items; track item) {
    <mat-option [value]="item.value">
      {{ item.value }}
    </mat-option>
    }
  </mat-select>
  <!-- Required error -->
  @if (control.hasError('required') && control.touched) {
  <mat-error>
    {{ dropDown.label }}&nbsp;{{
      'workflow.request-document.basic-details.required-error' | translate
    }}
  </mat-error>
  }
</mat-form-field>
}

<!-- External dropdown placeholder -->
@if (isExternalSelection) {
<mat-form-field appearance="fill" style="width: 100%">
  <mat-label>{{ dropDown.label }}</mat-label>
  <input
    type="text"
    placeholder="{{ dropDown.placeholder }}"
    matInput
    [(ngModel)]="externalDisplayValue"
    (ngModelChange)="onDisplayValueChange($event)"
    [matAutocomplete]="ExternalReference"
  />
  <mat-icon matSuffix class="custom-arrow-icon"> arrow_drop_down </mat-icon>
  <mat-autocomplete
    autoActiveFirstOption
    #ExternalReference="matAutocomplete"
    (optionSelected)="ExternalReferenceAction($event.option.value)"
  >
    @for (section of filteredExternalOptions; track section) {
    <mat-option [value]="section.displayValue">
      {{ section.displayValue }}
    </mat-option>
    }
  </mat-autocomplete>
  @if (control.hasError('required') && control.touched) {
  <mat-error>
    {{ dropDown.label }}&nbsp;{{
      'workflow.request-document.basic-details.required-error' | translate
    }}
  </mat-error>
  }
</mat-form-field>
}
